export default "__VITE_ASSET__4dd1d9cc__"